export var setScaleCtrl = function (map, opts) {
    var BMap = window['BMap'];
    //enable ScaleControl
    var scaleOpts = {};
    if (typeof opts.scaleCtrl !== 'boolean') {
        var ctrl = opts.scaleCtrl;
        if (ctrl.anchor) {
            scaleOpts.anchor = ctrl.anchor;
        }
        if (ctrl.offset) {
            scaleOpts.offset = new BMap.Size(ctrl.offset.width, ctrl.offset.height);
        }
        map.addControl(new BMap.ScaleControl(scaleOpts));
    }
    else if (opts.scaleCtrl) {
        map.addControl(new BMap.ScaleControl());
    }
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._angular2-baidu-map@3.0.2@angular2-baidu-map/dist/controls/ScaleControl.js
// module id = ../../../../._angular2-baidu-map@3.0.2@angular2-baidu-map/dist/controls/ScaleControl.js
// module chunks = 5